export enum RpmActionTypes {
  PatientComment = 'patient-comment',
  OutboundSmsWithTimer = 'outbound-sms-with-timer',
  OutboundScheduledSms = 'outbound-scheduled-sms',
  ReadingReview = 'reading-review',
  ReadingComment = 'reading-comment',
  ReadingCall = 'reading-call',
  ClinicalNotes = 'clinical-notes',
  BulkReadingReview = 'bulk-reading-review',
  BulkReadingCommentWithTimer = 'bulk-reading-comment-with-timer',
  BulkReadingComment = 'bulk-reading-comment',

  PatientMessage = 'patient-message',
  PatientMessageResponse = 'patient-message-response',
  PatientCall = 'patient-call',
  Manual = 'manual',
  MdReview = 'md-review',
  PatientICD = 'patient-icd',
  PatientICDUpdate = 'patient-icd-update',
  PatientICDDelete = 'patient-icd-delete',
  PatientMedications = 'patient-medications',
  PatientMedicationsUpdate = 'patient-medications-update',
  PatientMedicationsDelete = 'patient-medications-delete',
  PatientPastMedicalHistory = 'patient-past-medical-history',
  PatientPastMedicalHistoryUpdate = 'patient-past-medical-history-update',
  PatientPastMedicalHistoryDelete = 'patient-past-medical-history-delete',
}

export enum CcmActionTypes {
  OutboundScheduledSms = 'outbound-scheduled-sms',
  CCMPatientNotes = 'patient-notes',
  CCMPatientCallNotes = 'patient-call-notes',
  PatientGoals = 'patient-goals',
  PatientGoalsUpdate = 'patient-goals-update',
  PatientAllergyLog = 'patient-allergy-log',
  PatientAllergyLogUpdate = 'patient-allergy-log-update',

  PatientMessage = 'patient-message',
  PatientMessageResponse = 'patient-message-response',
  PatientCall = 'patient-call',
  Manual = 'manual',
  MdReview = 'md-review',
  PatientICD = 'patient-icd',
  PatientICDUpdate = 'patient-icd-update',
  PatientICDDelete = 'patient-icd-delete',
  PatientMedications = 'patient-medications',
  PatientMedicationsUpdate = 'patient-medications-update',
  PatientMedicationsDelete = 'patient-medications-delete',
  PatientPastMedicalHistory = 'patient-past-medical-history',
  PatientPastMedicalHistoryUpdate = 'patient-past-medical-history-update',
  PatientPastMedicalHistoryDelete = 'patient-past-medical-history-delete',
}

export enum ActionTypes {
  // common
  Manual = 'manual',
  MdReview = 'md-review',
  PatientCall = 'patient-call',
  PatientMessage = 'patient-message',
  PatientMessageResponse = 'patient-message-response',
  PatientICD = 'patient-icd',
  PatientICDUpdate = 'patient-icd-update',
  PatientICDDelete = 'patient-icd-delete',
  PatientMedications = 'patient-medications',
  PatientMedicationsUpdate = 'patient-medications-update',
  PatientMedicationsDelete = 'patient-medications-delete',
  PatientPastMedicalHistory = 'patient-past-medical-history',
  PatientPastMedicalHistoryDelete = 'patient-past-medical-history-delete',
  PatientPastMedicalHistoryUpdate = 'patient-past-medical-history-update',

  // RPM
  PatientComment = 'patient-comment',
  OutboundSmsWithTimer = 'outbound-sms-with-timer',
  OutboundScheduledSms = 'outbound-scheduled-sms',
  ReadingReview = 'reading-review',
  ReadingComment = 'reading-comment',
  ReadingCall = 'reading-call',
  ClinicalNotes = 'clinical-notes',
  BulkReadingReview = 'bulk-reading-review',
  BulkReadingCommentWithTimer = 'bulk-reading-comment-with-timer',
  BulkReadingComment = 'bulk-reading-comment',

  // CCM
  CCMPatientNotes = 'patient-notes',
  CCMPatientCallNotes = 'patient-call-notes',
  PatientGoals = 'patient-goals',
  PatientGoalsUpdate = 'patient-goals-update',
  PatientAllergyLog = 'patient-allergy-log',
  PatientAllergyLogUpdate = 'patient-allergy-log-update',

  All = 'all',
}
